import { DateTime } from 'luxon';

export default function formatDateFromMillis(
  msSinceEpoch: string | number | null
) {
  if (!msSinceEpoch) return '';
  return DateTime.fromMillis(Number(msSinceEpoch)).toFormat('MM-dd-yyyy');
}

export function formatDateFromSeconds(secSinceEpoch: string | number | null) {
  if (!secSinceEpoch) return '';
  return DateTime.fromSeconds(Number(secSinceEpoch)).toFormat('MM-dd-yyyy');
}
